import { render, staticRenderFns } from "./SettingsCRMView.vue?vue&type=template&id=33572715&scoped=true"
import script from "./SettingsCRMView.vue?vue&type=script&lang=js"
export * from "./SettingsCRMView.vue?vue&type=script&lang=js"
import style0 from "./SettingsCRMView.vue?vue&type=style&index=0&id=33572715&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33572715",
  null
  
)

export default component.exports